// Internal module imports
import { HttpClient } from '../utils/httpClient';

const PATH = {
    read: '/admin/mfrr/redis-current-data',
    activationEvents: '/admin/mfrr/activation-events',
    commandLogs: '/admin/mfrr/command-logs',
    powerLogs: '/admin/mfrr/power-logs',
};

const GetRedisCurrentData = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.read, { params }).then(callback).catch(error).finally(next);
};

const GetActivationEvents = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.activationEvents, { params }).then(callback).catch(error).finally(next);
};

const GetLogs = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.commandLogs, { params }).then(callback).catch(error).finally(next);
};

const GetPowerLogs = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.powerLogs, { params }).then(callback).catch(error).finally(next);
};

export const MFRRService = {
    GetRedisCurrentData,
    GetActivationEvents,
    GetLogs,
    GetPowerLogs
};
